import _pt from "prop-types";
import * as React from 'react';
import { DesignerFrontSide, PkpassContextProvider, Mask } from './components';
import { getInvertColor } from '../../utils/color';
import { ThemeProvider } from './Theme';
export const PkpassPreview = props => {
  const scale = props.scale || 1;
  const c = getInvertColor(props.pass.backgroundColor);
  const theme = {
    scale: scale,
    foregroundColor: props.pass.foregroundColor,
    labelColor: props.pass.labelColor,
    backgroundColor: props.pass.backgroundColor,
    dragOver: {
      border: `1px solid ${c}`,
      borderRadius: 5,
      boxShadow: `${c} 0px 0px 15px`,
      opacity: 0.5
    }
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 320 * scale,
      height: 450 * scale,
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(PkpassContextProvider, {
    pass: props.pass,
    images: props.images,
    scanDisabled: props.scanDisabled,
    onFieldClick: props.onFieldClick,
    onFieldDnD: props.onFieldDnD,
    onImageClick: props.onImageClick,
    onBarcodeClick: props.onBarcodeClick,
    onLogoTextClick: props.onLogoTextClick,
    onBoardingPassIconClick: props.onBoardingPassIconClick
  }, /*#__PURE__*/React.createElement(Mask, null), /*#__PURE__*/React.createElement(DesignerFrontSide, null))));
};
PkpassPreview.propTypes = {
  language: _pt.string,
  scanDisabled: _pt.bool,
  scale: _pt.number,
  onFieldClick: _pt.func,
  onFieldDnD: _pt.func,
  onImageClick: _pt.func,
  onBarcodeClick: _pt.func,
  onLogoTextClick: _pt.func,
  onBoardingPassIconClick: _pt.func
};
//# sourceMappingURL=PkpassPreview.js.map